import { render, staticRenderFns } from "./WidgetBarChart.vue?vue&type=template&id=020da29e"
import script from "./WidgetBarChart.vue?vue&type=script&lang=js"
export * from "./WidgetBarChart.vue?vue&type=script&lang=js"
import style0 from "./WidgetBarChart.vue?vue&type=style&index=0&id=020da29e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports